var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHttp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "10.6761 60.7274 177.7439 84.3909",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0ebd8"
    },
    d: "M 75.306 83.597 A 9.854 9.854 0 0 1 65.452 93.451 A 9.854 9.854 0 0 1 55.598 83.597 A 9.854 9.854 0 0 1 65.452 73.743 A 9.854 9.854 0 0 1 75.306 83.597 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0ebd8"
    },
    d: "M 75.305 114.45 C 75.305 119.892 70.894 124.304 65.451 124.304 C 60.009 124.304 55.597 119.892 55.597 114.45 C 55.597 109.008 60.009 104.596 65.451 104.596 C 70.894 104.596 75.305 109.008 75.305 114.45 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0ebd8",
      transformOrigin: "95.163px 102.944px"
    },
    d: "M 101.294 64.983 C 104.286 57.048 117.298 61.66 114.306 69.595 L 88.839 141.445 C 86.303 148.73 73.291 144.118 75.827 136.833 L 101.294 64.983 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0ebd8",
      transformOrigin: "124.573px 102.811px"
    },
    d: "M 130.704 64.85 C 133.696 56.915 146.708 61.527 143.716 69.462 L 118.249 141.312 C 115.713 148.597 102.701 143.985 105.237 136.7 L 130.704 64.85 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0ebd8"
    },
    d: "M 12.476 95.103 C 12.463 95.063 32.671 69.932 32.671 69.932 C 37.419 64.208 47.858 72.794 43.11 78.518 L 27.451 99.298 L 42.817 121.298 C 46.719 126.761 36.524 135.591 32.622 130.128 C 32.622 130.128 12.488 103.8 12.427 103.737 C 9.95 99.593 10.224 98.846 12.476 95.103 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0ebd8",
      transformOrigin: "171.598px 99.884px"
    },
    d: "M 186.62 104.727 C 186.633 104.767 166.425 129.898 166.425 129.898 C 161.677 135.622 151.238 127.036 155.986 121.312 L 171.645 100.532 L 156.279 78.532 C 152.377 73.069 162.572 64.239 166.474 69.702 C 166.474 69.702 186.608 96.03 186.669 96.093 C 189.146 100.237 188.872 100.984 186.62 104.727 Z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHttp);
export default __webpack_public_path__ + "static/media/http.eb770bc0b4ffd2ce066a72d365ca070d.svg";
export { ForwardRef as ReactComponent };